import { Linkedin, Instagram } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { Reveal, Overline } from "../Reveal";

export default function People() {
    const { site, tx } = useSite();
    const c = site?.content || {};
    const people = site?.people || [];

    return (
        <section id="people" data-testid="people-section" className="grain relative bg-[#F4F3EF] px-6 py-32 text-[#0A0A0A] md:px-12 md:py-48 lg:px-24">
            <Overline testId="people-overline">The team — 07</Overline>
            <Reveal>
                <h2 className="font-display mt-6 text-[clamp(3rem,7.5vw,7rem)] leading-[0.85]" data-testid="people-title">
                    {tx(c.people_title1) || "THE PEOPLE"}
                    <br />
                    <span className="text-outline-b">{tx(c.people_title2) || "BEHIND THE +."}</span>
                </h2>
            </Reveal>
            <Reveal delay={0.15}>
                <p className="mt-8 max-w-lg text-base leading-relaxed text-black/65">{tx(c.people_text)}</p>
            </Reveal>

            <div className="mt-20 grid grid-cols-2 gap-x-6 gap-y-16 md:grid-cols-3 lg:grid-cols-5">
                {people.map((p, i) => (
                    <Reveal key={p.id} delay={i * 0.08}>
                        <article data-testid={`person-card-${i}`} className="group" data-cursor="plus">
                            <div className="relative overflow-hidden bg-[#0A0A0A]">
                                <img
                                    src={p.photo_url}
                                    alt={p.name}
                                    loading="lazy"
                                    className="aspect-[3/4] w-full object-cover grayscale transition-all duration-700 ease-out group-hover:scale-[1.05] group-hover:grayscale-0"
                                />
                                <span className="font-display absolute left-3 top-2 text-2xl text-white/80" aria-hidden="true">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                            </div>
                            <h3 className="font-display mt-5 text-2xl leading-none md:text-3xl">{p.name}</h3>
                            <p className="mt-1.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#D60024]">{tx(p.role)}</p>
                            <p className="mt-3 text-xs leading-relaxed text-black/55 line-clamp-4">{tx(p.bio)}</p>
                            {(p.linkedin || p.instagram) && (
                                <div className="mt-3 flex gap-3 text-black/50">
                                    {p.linkedin && (
                                        <a href={p.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" data-testid={`person-linkedin-${i}`} className="hover:text-[#D60024] transition-colors">
                                            <Linkedin size={15} />
                                        </a>
                                    )}
                                    {p.instagram && (
                                        <a href={p.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid={`person-instagram-${i}`} className="hover:text-[#D60024] transition-colors">
                                            <Instagram size={15} />
                                        </a>
                                    )}
                                </div>
                            )}
                        </article>
                    </Reveal>
                ))}
            </div>
        </section>
    );
}
